function reducer(state, action) {
  switch (action?.type) {
    case "accounts": {
      return {
        ...state,
        accounts: action?.accounts || [],
      };
    }
    case "dataLine": {
      return {
        ...state,
        dataLine: action?.dataLine,
      };
    }
    default:
      return state;
  }
}

const initialState = {
  accounts: [],
  dataLine: {
    labels: "",
    datasets: [],
  },
};

export { reducer, initialState };
